module.exports = window["__sharedRedux"];